import { useContent } from '../../../../../redux/reducer/content';
import { challengeTaskUid } from '../../../../../constants/shared/ids/challengeTaskUid';

export const useChallengeQuests = () => {
  const { quests } = useContent();
  return quests?.filter(({ uid }) => uid === challengeTaskUid) ?? [];
};
